import { motion } from "framer-motion";
import { PillarNeuro, PillarAI, PillarTech } from "./Illustrations";

const PILLARS = [
  {
    name: "Neuroscience",
    body: "Informed by established research into human cognitive and physiological function.",
  },
  {
    name: "Artificial Intelligence",
    body: "Applied to interpret complex signals and support real-time understanding.",
  },
  {
    name: "Advanced Technology",
    body: "Engineered to operate reliably in demanding, real-world environments.",
  },
];

const reveal = {
  initial: { opacity: 0, y: 36 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.25 },
  transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] },
};

const Science = () => (
  <section id="science" className="py-24 md:py-32 px-6 md:px-16 lg:px-24 bg-[#080631]/40 border-t border-[#10B8B1]/10" data-testid="science-section">
    <div className="max-w-7xl mx-auto">
      <motion.div {...reveal}>
        <div className="flex items-center gap-5" data-testid="science-overline">
          <span className="font-mono-qelp text-[10px] tracking-[0.3em] uppercase text-[#10B8B1]">02</span>
          <span className="flex-1 h-px bg-white/10" />
          <span className="font-mono-qelp text-[10px] tracking-[0.3em] uppercase text-slate-600">Our Grounding</span>
        </div>
        <h2 className="mt-5 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-100 max-w-2xl" data-testid="science-heading">
          Built at the intersection of science and technology.
        </h2>
        <p className="mt-5 text-sm sm:text-base text-slate-400 leading-relaxed max-w-2xl">
          Qelp AI's work is grounded in established research, developed in collaboration with academic and clinical advisors, and shaped by peer-reviewed literature and structured, evidence-based methodology at every stage.
        </p>
      </motion.div>

      <div className="mt-14 grid md:grid-cols-3 gap-5">
        {PILLARS.map((p, i) => (
          <motion.div
            key={p.name}
            {...reveal}
            transition={{ ...reveal.transition, delay: i * 0.1 }}
            className="qelp-card rounded-3xl p-8 group"
            data-testid={`pillar-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="w-20 h-20 rounded-2xl border border-[#10B8B1]/30 bg-[#10B8B1]/5 flex items-center justify-center group-hover:bg-[#10B8B1]/15 transition-colors duration-500">
              {p.name === "Neuroscience" && <PillarNeuro />}
              {p.name === "Artificial Intelligence" && <PillarAI />}
              {p.name === "Advanced Technology" && <PillarTech />}
            </div>
            <h3 className="mt-6 font-heading text-lg sm:text-xl font-semibold text-white">{p.name}</h3>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">{p.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Science;
